import { Injectable } from '@angular/core';
import { Observable, combineLatest, of } from 'rxjs';
import { catchError, map, shareReplay, switchMap, take } from 'rxjs/operators';

import { ApiService, Subscription } from './api.service';
import { MyAuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class SubscriptionEntitlementService {
  private access$?: Observable<boolean>;

  constructor(
    private readonly api: ApiService,
    private readonly auth: MyAuthService
  ) {}

  canAccessWorkspace(): Observable<boolean> {
    if (!this.access$) {
      this.access$ = combineLatest([this.auth.isAdmin(), this.auth.isSales()]).pipe(
        take(1),
        switchMap(([isAdmin, isSales]) => {
          if (isAdmin || isSales) return of(true);
          return this.api.getMySubscription().pipe(
            map(({ subscription }) => this.subscriptionGrantsAccess(subscription)),
            catchError(() => of(false))
          );
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }

    return this.access$;
  }

  refresh(): void {
    this.access$ = undefined;
  }

  private subscriptionGrantsAccess(subscription: Subscription | null): boolean {
    if (!subscription) return false;
    if (subscription.status === 'active') return true;
    if (subscription.status !== 'canceling' || !subscription.currentPeriodEnd) return false;
    return new Date(subscription.currentPeriodEnd).getTime() > Date.now();
  }
}
